<template>
  <div>
<v-tabs
    centered
    dark
    icons-and-text
  >

    <v-tab  :key="1">
      Profile
      <v-icon>account_box</v-icon>
    </v-tab>

    <v-tab  :key="2">
      Tokens
      <v-icon>vpn_key</v-icon>
    </v-tab>


    <v-tab-item :key="1" >
    <v-card flat>


        <v-card-text>
          <v-form>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 xs6 md11>
                  <v-text-field
                    v-model="setup_user.firstname"
                    label="First name"
                    :rules="[rules.required]"
                    hint="Set user first name"/>
                </v-flex>
                <v-flex xs12 xs6 md11>
                  <v-text-field
                    v-model="setup_user.lastname"
                    :rules="[rules.required]"
                    label="Last name"
                    hint="Set user last name"/>
                </v-flex>
               <v-flex xs12 xs6 md11>
                  <v-text-field
                    v-model="setup_user.skype"
                    :rules="[rules.required]"
                    label="User Skype"
                    hint="Set user skype"/>
                </v-flex>
                <v-flex xs12 xs6 md11>
                  <v-text-field
                    v-model="setup_user.useremail"
                    :rules="[rules.required]"
                    label="User Email"
                    hint="Set user email"/>
                </v-flex>

                <v-flex xs12 xs6 md1 />

                <v-flex xs12 sm6 md11>
                  <v-text-field
                    v-model="setup_user.password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    label="New Password"
                    hint="Please choose a complex one.."
                    :error="error"
                    @click:append="showPassword = !showPassword" />
                </v-flex>

                <v-flex xs12 sm6 md1 />

                <v-flex xs12 sm6 md11>
                  <v-text-field
                    v-model="setup_user.passwordConfirm"
                    :append-icon="showPasswordConfirm ? 'visibility_off' : 'visibility'"
                    :type="showPasswordConfirm ? 'text' : 'password'"
                    label="Confirm New Password"
                    hint="and confirm it."
                    :error="error"
                    @click:append="showPasswordConfirm = !showPasswordConfirm" />
                </v-flex>

                <v-flex xs12 sm6 md1 />
                <v-flex xs12 xs6 md1 />

              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
       <v-btn color="primary" @click="update_profile">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-tab-item>
    <v-tab-item :key="2" >
      <v-toolbar flat color="white">
      <v-toolbar-title>My Tokens</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on"  @click="getnewtoken" >New Item</v-btn>
          </template>

        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm8 md12>
                  <v-text-field v-model="editedItem.token" label="Token"></v-text-field>
                </v-flex>
                <v-flex xs12 sm8 md12>
                  <v-text-field v-model="editedItem.description" label="description"></v-text-field>
                </v-flex>
                <v-flex xs12 sm8 md12>
                  <v-text-field v-model="editedItem.start" label="start"></v-text-field>
                </v-flex>
                <v-flex xs12 sm8 md12>
                  <v-text-field v-model="editedItem.expire" label="expire"></v-text-field>
                </v-flex>
                <v-flex xs12 sm8 md12>
                    <v-switch v-model="editedItem.permanent"   label="permanent"></v-switch>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="tokens"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td >{{ props.item.token }}</td>
        <td >{{ props.item.description }}</td>
        <td >{{ props.item.start }}</td>
        <td >{{ props.item.expire }}</td>
        <td >{{ props.item.permanent }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    </v-tab-item>

  </v-tabs>
      <v-snackbar
        v-model="showResult"
        :timeout="5000"
        top>
        {{ result }}
      </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      setup_user: {},
      loading: false,
      hidePassword: true,
      showPassword: null,
      showPasswordConfirm: null,
      error: false,
      showResult: false,
      result: '',
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      rules: {
        required: value => !!value || 'Required.'
      },
      dialog: false,
      headers: [
        {
          text: 'token',
          align: 'left',
          sortable: false,
          value: 'token'
        },
        { text: 'description', value: 'description' },
        { text: 'start', value: 'start' },
        { text: 'expire', value: 'expire' },
        { text: 'permanent', value: 'permanent' },
        { text: 'Actions', value: 'token', sortable: false }
      ],
      tokens: [],
      editedIndex: -1,
      editedItem: {
        ftid: '',
        token: '',
        description: '',
        start: 0,
        expire: 0,
        permanent: 0
      },
      defaultItem: {
        ftid: '',
        token: '',
        description: '',
        start:  new Date().toISOString().substr(0, 10),
        expire: new Date('2222-12-31').toISOString().substr(0, 10),
        permanent: false
      }
    }
  },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }

    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    mounted() {
        var locstor = JSON.parse(localStorage.getItem("profile"));
        this.setup_user = locstor.user[0];
        this.setup_user.password = "";
        this.setup_user.passwordConfirm = "";


    },


  methods: {

    formatdate (date) {
      return new Date(date).toISOString().substr(0, 10);
    },


    update_profile(){
      const vm = this.setup_user;
      const vm1 = this;


      if (vm.firstname === null || vm.lastname === null || vm.skype === null) {

        vm1.result = "need First Name Last Name skype";
        vm1.showResult = true;

        return;
      }

      if (vm.password !== vm.passwordConfirm) {

        vm1.error = true;
        vm1.result = "Passwords does not match the confirm password.";
        vm1.showResult = true;

        return;
      }

      if (vm.firstname != null || vm.lastname != null || vm.skype != null || vm.email != null) {
         if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}

          this.$http
              .put(this.$root.apiUrl+'/api/v1/user/profile', vm)
              .then(r => {
                // console.log('r: ', JSON.stringify(r, null, 2));
                if(r.status === 204){
                  var locstor = JSON.parse(localStorage.getItem("profile"));
                  locstor.user[0] = vm;
                  localStorage["profile"] = JSON.stringify(locstor);
                  vm1.result = "Update ok";
                  vm1.showResult = true;
                } else {
                  vm1.result = "update error.";
                  vm1.showResult = true;
                }

      });
     }
    },
    initialize () {
         if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}

          this.$http
              .get(this.$root.apiUrl+'/api/v1/user/tokens')
              .then(r => {
                // console.log('r: ', JSON.stringify(r, null, 2));
                if(r.status === 200){
                  this.tokens = r.data.result;
                }

      });
      },


      getnewtoken () {
        if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}
        this.$http
              .get(this.$root.apiUrl+'/api/v1/user/newtoken')
              .then(r => {
                // console.log('r: ', JSON.stringify(r, null, 2));
                if(r.status === 200){
                  this.editedItem = r.data.result;
                }

      });
      },

      editItem (item) {
        this.editedIndex = this.tokens.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.tokens.indexOf(item)
        // console.log(this.tokens[index]);
        if(confirm('Are you sure you want to delete this token?')) {
        if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}
        this.$http
              .delete(this.$root.apiUrl+'/api/v1/user/token/'+this.tokens[index].ftid)
              .then(r => {
                // console.log('r: ', JSON.stringify(r, null, 2));
                if(r.status === 202){
                   this.tokens.splice(index, 1)
                }

      });

          }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {

        if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}
        this.$http
              .put(this.$root.apiUrl+'/api/v1/user/token', this.editedItem)
              .then(r => {
                // console.log('r: ', JSON.stringify(r, null, 2));
                if(r.status === 204){
                   Object.assign(this.tokens[this.editedIndex], this.editedItem)
                }

      });
        } else {

        if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}
        this.$http
              .post(this.$root.apiUrl+'/api/v1/user/newtoken', this.editedItem)
              .then(r => {
                // console.log('r: ', JSON.stringify(r, null, 2));
                if(r.status === 201){
                  // console.log(r.data);
                  this.editedItem.ftid = r.data.ftid;
                  this.tokens.push(this.editedItem)

                }

      });
        }
        this.close()
        // console.log(this.editedItem);
      }
    }

}
</script>



// WEBPACK FOOTER //
// src/pages/Profile.vue